const slug = (value: string): string => (value ? value.replace(/\W+/g, '-') : '');

export default slug;
